import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';

if (process.env.NODE_ENV === 'production') {
  ReactGA.initialize('UA-109711452-4');
}

ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();
